// extracted by mini-css-extract-plugin
export default {"GiftItem":"GiftItem_GiftItem__66bSm","activeGift":"GiftItem_activeGift__Rk9QH","GiftImage":"GiftItem_GiftImage__DBREc","GiftText":"GiftItem_GiftText__aJX2o"};